import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'categoria-card',
    templateUrl: './categoria-card.component.html',
    styleUrls: ['./categoria-card.component.scss'],
    standalone: false
})
export class CategoriaCardComponent {
  @Output('p-click') click = new EventEmitter<MouseEvent>();
  @Input('p-description') description: string;
  @Input('p-title') title: string;
  @Input('p-image') image: string;
}